import '../application.css';

import React from 'react';
import { createRoot } from 'react-dom/client';
import { AuthProvider } from "../contexts/auth-context"
import { TranslationProvider } from "../contexts/translation-context"
import HomePage from './app';

// Target an element in the HTML to mount React into
const rootElement = document.getElementById('react-root');
if (rootElement) {
  const root = createRoot(rootElement);
  root.render(
    <TranslationProvider>
      <AuthProvider>
        <HomePage />
      </AuthProvider>
    </TranslationProvider>
  );
}

console.log('Vite ⚡️ Rails')
